<template>
  <div>
    <mainHeader title="Account Records"></mainHeader>
    <div style="padding: 0 12px;">
      <h1>Account Records</h1>
      <h2>Blance: {{ blance }}</h2>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Time</th>
            <th scope="col">Amount</th>
            <th scope="col">Blance</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.id">
            <td>{{ item.remark }}</td>
            <td>{{ formatTime(item.addtime * 1000) }}</td>
            <td :class="item.money > 0 ? 'text-success' : 'text-danger'">{{ item.money }}</td>
            <td>{{ item.blance }}</td>
          </tr>
        </tbody>
      </table>
      <Pagination
        v-if="page.total > page.pageSize"
        :total="page.total"
        :pageSize="page.pageSize"
        v-model:currentPage="page.currentPage"
        @change="handlePageChange"
      />
    </div>

  </div>
</template>

<script>
import dayjs from "dayjs";
import { getUserAccountList } from "@/apis/wallet";
import Pagination from "@/components/Pagination.vue";
import mainHeader from '@/components/mainHeader.vue';

export default {
  data() {
    return {
      data: [],
      page: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      blance : 0.00
    };
  },
  components: {
    mainHeader,
    Pagination,
  },
  created() {
    this.getData();
  },
  methods: {
    formatTime(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    getData() {
      getUserAccountList({
        page: this.page.currentPage,
        rows: this.page.pageSize,
      }).then((res) => {
        console.log(res);
        this.data = res.data;
        this.blance = res.blance;
        this.page.total = res.count;
      });
    },
    handlePageChange(page) {
      console.log(page);
      this.getData();
    },
  },
};
</script>

<style></style>
